__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-document-upload-form'].baseUrl;
import DocumentUploadForm from './components/DocUploadForm';
export default DocumentUploadForm;
;
if (!global.BROWSER) {
  DocumentUploadForm.appConfig = Object.assign({}, DocumentUploadForm.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}